import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { refreshScripts } from './utilities'
import { initLenis, scrollToStart } from './lenis'
import { initAlpine } from './alpine'
import { initSplitText } from './splitType'
import { initParallax } from './parallax'
import { initAnimations } from './animation'
import { initTestimonials } from './testimonials'
import { initInviewAnimations } from './inview'
import { initIntercom } from './intercom'
import { initFormie } from './formie'
import { initSprig } from './sprig'
import { initCursor, initCursorEvents } from './cursor'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {
	window.initialLoad = true

	const nav = new Navigation()

	const initComponents = (data) => {
		initSplitText()
		initAnimations()
		initTestimonials()
		initInviewAnimations()
		initParallax()
		initSprig()
		initCursorEvents()
	}

	let pendingHash = null

	barba.init({
		debug: false,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				once(data) { },
				leave(data) {
          const done = this.async()

					pendingHash = data.trigger?.hash || null

          gsap.to(data.current.container, {
            opacity: 0,
            duration: 0.35,
            onComplete: done,
          })
				},
				afterLeave() {
					scrollToStart()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
          const done = this.async()

          gsap.from(data.next.container, {
            opacity: 0,
            duration: 0.35,
            onComplete: done,
          })

					if (pendingHash) {
						setTimeout(() => {
							const target = document.querySelector(pendingHash);
							if (target) {
								target.scrollIntoView({ behavior: 'smooth' });
								history.replaceState(null, null, pendingHash);
							}
							pendingHash = null;
						}, 1000);
					} else {
						pendingHash = null;
					}
				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initCursor()
		initIntercom()
		initComponents(data)

		window.onload = function() {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.enter((data) => {
    if (htmx) {
      htmx.process(data.next.container)
    }
  })

	barba.hooks.after((data) => {
		initComponents(data)
		initFormie()
		refreshScripts(data.next.container)
	})
}

export default initBarba